/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ContentTranslationResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  title: string;
  detail: string;
  language: ContentTranslationResponseDto.LanguageEnum;
}
// tslint:disable-next-line:no-namespace
export namespace ContentTranslationResponseDto {
  export type LanguageEnum = 'th' | 'en';
  export const LanguageEnum = {
      Th: 'th' as LanguageEnum,
      En: 'en' as LanguageEnum,
  };
}
